import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  let role = authService.userRole();
  const userJson = localStorage.getItem('CURRENT_USER');

  if (!role && userJson) {
    try {
      const user = JSON.parse(userJson);
      role = user.role;
      authService.currentUser.set(user);
    } catch (e) {}
  }

  const normalizedRole = (role || '').toUpperCase();
  const isAuthorized = normalizedRole === 'SUPER_ADMIN';

  console.log(`[AdminGuard] Role: ${normalizedRole}, Authorized: ${isAuthorized}`);

  if (isAuthorized) {
    return true;
  }

  console.warn(`[AdminGuard] Access denied. Redirecting to login.`);
  router.navigate(['/auth/login']);
  return false;
};
